// extracted by mini-css-extract-plugin
export var growableInput = "_6c-0";
export var tagContainer = "_6c-2";
export var textInput = "_6c-1";